// extracted by mini-css-extract-plugin
export default {"pageContainer":"dcc_error-pageContainer","pageContent":"dcc_error-pageContent"};